// extracted by mini-css-extract-plugin
var _1 = "_GoldConversionTable-module__gold-row";
var _2 = "_GoldConversionTable-module__show-serial-no";
export { _1 as "gold-row", _2 as "show-serial-no" }
